import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getWinnersList = createAsyncThunk(
  'winner/getWinnersList',
  async ({ lottery_brand_day_id, skip, limit, draw_date, draw_no }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(lottery_brand_day_id ? { lottery_brand_day_id } : {}),
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(draw_date ? { draw_date } : {}),
          ...(draw_no ? { draw_no } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/get-winner-list`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const publishWinnerInfo = createAsyncThunk(
  'winner/publishWinnerInfo',
  async (winnerData, { rejectWithValue }) => {
    try {  
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      
      const body = JSON.stringify(winnerData);

      const response = await axios.put(
        `${PUBLIC_BASE_URL}/tickets/winner-publish`,
        body,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);
